import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../apiClient";

export const deleteRegularClassSchedulesSimulate = ({ id }) => {
  return api.delete(`admin/regular-class-schedules-simulate/${id}`);
};

export const deleteRegularClassSchedulesSimulateQueryOptions = data => {
  return queryOptions({
    queryKey: ["delete-regular-class-schedules-simulate", data],
    queryFn: () => deleteRegularClassSchedulesSimulate(data),
  });
};

export const useDeleteRegularClassSchedulesSimulate = ({
  queryConfig = {},
  ...data
}) => {
  return useQuery({
    ...deleteRegularClassSchedulesSimulateQueryOptions(data),
    ...queryConfig,
  });
};
